import { FC, useEffect, useState } from "react";
import ProfileHeader from "../../components/Profile/ProfileHeader/ProfileHeader";
import ProfileStore from "../../components/Profile/ProfileStore/ProfileStore";
import Post from "../../components/Post/Post";
import { Link, useParams } from "react-router-dom";
import styles from "./Profile.module.css";
import { useFetchedUserContext } from "../../context/fetchedUser/FetchedUser";
import { useTranslation } from "react-i18next";
import NotFound from "../Static/NotFound";

export enum ProfileViewMode {
  posts = 1,
  profileStore = 2,
}

interface ProfileProps {
  viewModeValue?: ProfileViewMode;
}

const Profile: FC<ProfileProps> = ({
  viewModeValue = ProfileViewMode.profileStore,
}) => {
  const [radioValue, setRadioValue] = useState<number>(viewModeValue.valueOf()); // Default selected value
  const { username } = useParams();
  const fetchedUserContext = useFetchedUserContext();
  const { t } = useTranslation();

  useEffect(() => {
    if (!username || username === fetchedUserContext.user?.username) {
      return;
    }

    fetchedUserContext.fetchUser(username);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  const radios = [
    // { name: "Posts", value: 1 },
    { name: t("store.label"), value: 2 },
  ];

  const contentMap: { [key: number]: JSX.Element } = {
    1: <Post />,
    2: <ProfileStore />,
  };

  return (
    <>
      {fetchedUserContext.user ? (
        <>
          <ProfileHeader />
          <div className={styles.buttonGroup}>
            {radios.map((radio, index) => (
              <Link
                to={`/profile/${username}/${radio.name}`}
                className={styles.unset}
                key={index}
              >
                <div
                  key={index}
                  className={`${styles.toggleButton} ${
                    radio.value === radioValue ? styles.active : ""
                  }`}
                  onClick={() => setRadioValue(radio.value)}
                >
                  {radio.name}
                </div>
              </Link>
            ))}
          </div>

          <div>{contentMap[radioValue]}</div>
        </>
      ) : (
        <div>
          <NotFound />
        </div>
      )}
    </>
  );
};

export default Profile;
